module.exports = __webpack_public_path__ + "static/img/1-7.36b35273.png";